import { render, staticRenderFns } from "./CargoOverdueBell.vue?vue&type=template&id=47e3773e&scoped=true"
import script from "./CargoOverdueBell.vue?vue&type=script&lang=js"
export * from "./CargoOverdueBell.vue?vue&type=script&lang=js"
import style0 from "./CargoOverdueBell.vue?vue&type=style&index=0&id=47e3773e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47e3773e",
  null
  
)

export default component.exports